<h2 mat-dialog-title>Bedankingsmail</h2>

<hr />

<mat-spinner
  class="spinner-middle"
  *ngIf="!init || sending"
  color="primary"
  diameter="24"
></mat-spinner>

<mat-dialog-content>
  <div *ngIf="init && !sending">
    <br />

    <div class="form-sub-title">Selecteer ontvangers</div>

    <mat-form-field class="" appearance="outline">
      <mat-select
        matInput
        multiple
        placeholder="Ontvangers"
        name="contacts"
        [(ngModel)]="selectedContacts"
        [compareWith]="compareEntities"
      >
        <mat-option *ngFor="let option of contactOptions" [value]="option">
          {{ option.firstName }} {{ option.lastName }}:
          {{
            option.emails && option.emails.length > 0
              ? option.emails[0].email
              : 'Geen e-mailadres'
          }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="form-sub-title">Geselecteerde ontvangers</div>

    <div *ngIf="selectedContacts == null || selectedContacts.length === 0">
      Geen ontvangers geselecteerd
    </div>

    <ul>
      <li *ngFor="let contact of selectedContacts">
        {{ contact.firstName }} {{ contact.lastName }}:
        {{
          contact.emails && contact.emails.length > 0
            ? contact.emails[0].email
            : 'Geen e-mailadres'
        }}
      </li>
    </ul>

    <div *ngIf="inputSubProject.type !== 'Repo'">
      <div class="form-sub-title">Kies foto's</div>

      <div *ngIf="assetOptions == null || assetOptions.length === 0">
        Geen plaatsingsfoto's
      </div>

      <div *ngFor="let option of assetOptions">
        <div
          class="img-preview clickable"
          [ngClass]="
            assetIsSelected(option.id) ? 'selected-photo' : 'non-selected-photo'
          "
          *ngIf="isImage(option.asset)"
          (click)="toggleSelectAsset(option)"
        >
          <img
            class="preview-image"
            src="/api/assets/{{ option.asset.uuid }}"
          />
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="float-right">
  <button type="button" (click)="closeDialog()" class="btn btn-main btn-back">
    Annuleer
  </button>

  <button
    type="button"
    (click)="sendMail()"
    mat-button
    class="button"
    id="btnSend"
    [disabled]="sending"
  >
    Verstuur bedankingsmail
  </button>
</mat-dialog-actions>
